import React, { useState, useEffect, Fragment } from 'react';
import { Row, Card, Button } from 'reactstrap';
import Select from 'react-select';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import {
    AxiosAPI, getGroupID,

} from '../../../../../helpers/AxiosAPI';
import {
    gAPI_CheckUser_Property,
    gAPI_Site_Settings,
    gAPI_Group_By_Id,
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { gAPI_Groups } from '../../../../../constants/APIs';
import { reactSelectOptionDiffrentProWithKeyValue, sortPropertyListByName } from '../../../../../helpers/Utils';
import ServiceProviderForm from './Components/serviceProviderForm';
import { Axios } from 'axios';
import { themeColorStorageKey } from "../../../../../constants/defaultValues";

function Index({ propertyId, history }) {
    const [isVisible, setIsVisible] = useState(false);
    const [serviceProvider, setServiceProvider] = useState();
    const [siteSettings, setSiteSettingsList] = useState([]);
    const [activeService, setActiveService] = useState(null);


    const toggle = () => {
        setIsVisible(!isVisible);
        setServiceProvider();
    }

    const handleServiceProvider = (item) => {
        setIsVisible(!isVisible);
        setServiceProvider(item);
    }

    useEffect(() => {
        loadList();

    }, [propertyId]);

    const loadList = () => {
        setServiceProvider();
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Site_Settings}`,
        })
            .then(res => {

                if (res.data.length > 0) {
                    setSiteSettingsList(res.data);
                    fetchServiceProviderData(res.data);
                }
            });
    }

    const fetchServiceProviderData = (siteData) => {
        AxiosAPI({
            method: "get",
            url: `${gAPI_Group_By_Id}/${getGroupID()}`,
        })
            .then((res) => {
                if (res.data && res.data.serviceProvider) {
                    setActiveService(res.data.serviceProvider);
                    // console.log('fetchtheme', this.state.serviceProvider, this.fetchColorTheme(res.data.serviceProvider),)
                    fetchColorTheme(siteData, res.data.serviceProvider);
                }
            })
            .catch((error) => {
                console.error("Error fetching service provider data:", error);
            });
    };

    const fetchColorTheme = (siteData, activeService) => {

        if (siteData && siteData.length > 0) {
            // const serviceToMatch = (activeService === 'aiva' || activeService === 'Sabre') ? 'Sabre' : activeService;
            const matchedService = siteData.find(item => item.id.toString() === activeService);

            if (matchedService) {
                const color = matchedService.colorTheme || 'light.purple';  // Default to 'light.purple' if colorTheme is not found
                localStorage.setItem(themeColorStorageKey, color);
            } else {
                localStorage.setItem(themeColorStorageKey, 'light.purple');

            }
        }

    };

    return (
        <Fragment>
            <Row>
                <Colxx xxs="12" md="8" className="mb-4">
                    <div className="align-vertical-center">
                        <h2>
                            Service Providers
                        </h2>
                    </div>
                </Colxx>
            </Row>
            <Row>
                <Colxx xxs="12" md="12" className="mb-4">
                    {siteSettings !== undefined && siteSettings.length > 0 && siteSettings.map(item => <Fragment>
                        <Card className="d-flex flex-row mb-3">
                            <div className="pl-0 d-flex flex-grow-1 min-width-zero col-2">
                                <img
                                    alt="Thumbnail"
                                    src={
                                        item.logo != ""
                                            ? item.logo
                                            : 'https://via.placeholder.com/250x150'
                                    }
                                    className="list-thumbnail responsive border-0 ml-2"
                                />
                            </div>
                            <div className="pl-2 d-flex flex-grow-1 min-width-zero col-10">
                                <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                                    <p className="mb-1 text-muted text-small w-10 w-sm-100">
                                        {item.fromName}
                                    </p>
                                    <p className="mb-1 text-muted text-small w-10 w-sm-100">
                                        {item.from}
                                    </p>
                                    <p className="mb-1 text-muted text-small w-10 w-sm-100">
                                        {item.senderAddress}
                                    </p>
                                    <p className="mb-1 text-muted text-small w-10 w-sm-100">
                                        {item.senderCity}
                                    </p>
                                    <p className="mb-1 text-muted text-small w-10 w-sm-100">
                                        {item.senderZip}
                                    </p>
                                    <div className="w-10 w-sm-100">
                                        <Button outline color='primary' onClick={() => handleServiceProvider(item)}>
                                            Edit
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Fragment>)}
                </Colxx>
            </Row>
            <Row>
                <Colxx xxs="12" md="12" className="mb-4">
                    {serviceProvider !== undefined && <ServiceProviderForm loadList={loadList} isVisible={isVisible} toggle={toggle} data={serviceProvider}></ServiceProviderForm>}
                </Colxx>
            </Row>
        </Fragment>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
